(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koji-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.koji-how-it-works').forEach(function (root) {
      if (root.dataset.kojiHowInit) return;
      root.dataset.kojiHowInit = '1';

      var video = root.querySelector('[data-how-video]');
      if (!video) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // reduced-motion → zostaje sam plakat, nic nie pobieramy
      if (reduce) return;

      var loaded = false;
      function load() {
        if (loaded) return;
        loaded = true;
        video.querySelectorAll('source[data-src]').forEach(function (s) {
          s.src = s.getAttribute('data-src');
        });
        video.load();
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
      }

      if (!('IntersectionObserver' in window)) { load(); return; }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { load(); io.disconnect(); }
        });
      }, { rootMargin: '200px' });
      io.observe(video);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koji-opinie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.koji-opinie').forEach(function (root) {
      if (root.dataset.kojiOpinieInit) return;
      root.dataset.kojiOpinieInit = '1';

      var list = root.querySelector('[data-opinie-list]');
      if (!list) return;
      var more = root.querySelector('[data-opinie-more]');
      var sortSel = root.querySelector('[data-opinie-sort]');
      var empty = root.querySelector('[data-opinie-empty]');
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
      var batch = more ? (parseInt(more.dataset.batch, 10) || 6) : 6;
      var items = Array.prototype.slice.call(list.querySelectorAll('.opinie__item'));
      var filter = 'all';
      var shown = 0;
      var matched = [];

      function keep(li) {
        if (filter === 'all') return true;
        var r = parseInt(li.getAttribute('data-rating'), 10);
        if (filter === 'low') return r <= 3;
        return r === parseInt(filter, 10);
      }

      function reorder() {
        var mode = sortSel ? sortSel.value : 'new';
        if (mode === 'best' || mode === 'crit') {
          var arr = items.slice();
          arr.sort(function (a, b) {
            var ra = +a.getAttribute('data-rating'), rb = +b.getAttribute('data-rating');
            if (ra !== rb) return mode === 'best' ? rb - ra : ra - rb;
            return (b.getAttribute('data-date') || '').localeCompare(a.getAttribute('data-date') || '');
          });
          arr.forEach(function (li) { list.appendChild(li); });
          return arr;
        }
        items.forEach(function (li) { list.appendChild(li); });
        return items.slice();
      }

      function render() {
        var ordered = reorder();
        matched = ordered.filter(keep);
        items.forEach(function (li) { li.hidden = true; });
        shown = Math.min(batch, matched.length);
        matched.slice(0, shown).forEach(function (li) { li.hidden = false; });
        if (empty) empty.hidden = matched.length > 0;
        if (more) more.hidden = shown >= matched.length;
      }

      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          filter = btn.getAttribute('data-filter');
          filters.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          render();
        });
      });

      if (sortSel) sortSel.addEventListener('change', render);

      if (more) {
        more.addEventListener('click', function () {
          matched.slice(shown, shown + batch).forEach(function (li) { li.hidden = false; });
          shown = Math.min(shown + batch, matched.length);
          more.hidden = shown >= matched.length;
        });
      }

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koji-pdp-opinie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.koji-pdp-opinie').forEach(function (root) {
      if (root.dataset.kojiFtOpinieInit) return;
      root.dataset.kojiFtOpinieInit = '1';

      var list = root.querySelector('[data-opinie-list]');
      if (!list) return;
      var more = root.querySelector('[data-opinie-more]');
      var sortSel = root.querySelector('[data-opinie-sort]');
      var empty = root.querySelector('[data-opinie-empty]');
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
      var batch = more ? (parseInt(more.dataset.batch, 10) || 6) : 6;
      var items = Array.prototype.slice.call(list.querySelectorAll('.ftopinie__item'));
      var filter = 'all';
      var shown = 0;
      var matched = [];

      function keep(li) {
        if (filter === 'all') return true;
        var r = parseInt(li.getAttribute('data-rating'), 10);
        if (filter === 'low') return r <= 3;
        return r === parseInt(filter, 10);
      }

      function reorder() {
        var mode = sortSel ? sortSel.value : 'new';
        if (mode === 'best' || mode === 'crit') {
          var arr = items.slice();
          arr.sort(function (a, b) {
            var ra = +a.getAttribute('data-rating'), rb = +b.getAttribute('data-rating');
            if (ra !== rb) return mode === 'best' ? rb - ra : ra - rb;
            return (b.getAttribute('data-date') || '').localeCompare(a.getAttribute('data-date') || '');
          });
          arr.forEach(function (li) { list.appendChild(li); });
          return arr;
        }
        items.forEach(function (li) { list.appendChild(li); });
        return items.slice();
      }

      function render() {
        var ordered = reorder();
        matched = ordered.filter(keep);
        items.forEach(function (li) { li.hidden = true; });
        shown = Math.min(batch, matched.length);
        matched.slice(0, shown).forEach(function (li) { li.hidden = false; });
        if (empty) empty.hidden = matched.length > 0;
        if (more) more.hidden = shown >= matched.length;
      }

      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          filter = btn.getAttribute('data-filter');
          filters.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          render();
        });
      });

      if (sortSel) sortSel.addEventListener('change', render);

      if (more) {
        more.addEventListener('click', function () {
          matched.slice(shown, shown + batch).forEach(function (li) { li.hidden = false; });
          shown = Math.min(shown + batch, matched.length);
          more.hidden = shown >= matched.length;
        });
      }

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koji-pdp-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.koji-pdp-video').forEach(function (root) {
      if (root.dataset.kojiFtVideoInit) return;
      root.dataset.kojiFtVideoInit = '1';

      var videos = root.querySelectorAll('[data-ftvideo]');
      if (!videos.length) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // reduced-motion → nie pobieramy ani nie odtwarzamy niczego
      if (reduce) return;

      // zrodlo jest juz w <source>, wiec preload="metadata" pokaze pierwsza klatke
      // od razu — obserwator steruje wylacznie odtwarzaniem
      function play(video) {
        var p = video.play();
        if (p && p.catch) {
          p.catch(function () {});
        }
      }

      if (!('IntersectionObserver' in window)) {
        videos.forEach(play);
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play(entry.target);
            } else if (!entry.target.paused) {
              // poza ekranem nie ma po co mielic baterii
              entry.target.pause();
            }
          });
        },
        { rootMargin: '200px' }
      );

      videos.forEach(function (v) {
        io.observe(v);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koji-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.koji-stories').forEach(function (root) {
      if (root.dataset.kojiStoriesInit) return;
      root.dataset.kojiStoriesInit = '1';

      var vp = root.querySelector('[data-stories-viewport]');
      var prev = root.querySelector('[data-stories-prev]');
      var next = root.querySelector('[data-stories-next]');
      if (!vp || !prev || !next) return;

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-stories-dot]'));
      var cards = vp.children;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function go(dir) {
        vp.scrollBy({ left: dir * vp.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      function activeIndex() {
        // najbliższa karta względem lewej krawędzi viewportu
        var best = 0;
        var bestDelta = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var delta = Math.abs(cards[i].offsetLeft - vp.scrollLeft);
          if (delta < bestDelta) { bestDelta = delta; best = i; }
        }
        return best;
      }

      function sync() {
        var max = vp.scrollWidth - vp.clientWidth - 4;
        prev.toggleAttribute('disabled', vp.scrollLeft <= 4);
        next.toggleAttribute('disabled', vp.scrollLeft >= max);
        if (dots.length) {
          var idx = activeIndex();
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === idx);
            if (i === idx) { d.setAttribute('aria-selected', 'true'); }
            else { d.removeAttribute('aria-selected'); }
          });
        }
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (cards[i]) {
            vp.scrollTo({ left: cards[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
          }
        });
      });
      // drag-to-scroll dla myszy/pena; na dotyku działa natywny scroll-snap swipe
      var down = false, sx = 0, sl0 = 0, moved = false;
      vp.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = false;
        sx = e.clientX; sl0 = vp.scrollLeft;
        vp.classList.add('is-grab');
        vp.style.scrollSnapType = 'none';
        try { vp.setPointerCapture(e.pointerId); } catch (err) {}
      });
      vp.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 4) moved = true;
        vp.scrollLeft = sl0 - dx;
      });
      function endDrag() {
        if (!down) return;
        down = false;
        vp.classList.remove('is-grab');
        vp.style.scrollSnapType = '';
        var i = activeIndex();
        if (cards[i]) vp.scrollTo({ left: cards[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
      vp.addEventListener('pointerup', endDrag);
      vp.addEventListener('pointercancel', endDrag);
      vp.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      vp.addEventListener('dragstart', function (e) { e.preventDefault(); });

      vp.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koji-transformace"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.koji-transformace');
  roots.forEach(function(root){
    var cmp = root.querySelector('.cmp');
    if(!cmp) return;
    var r = cmp.querySelector('.cmp__range');
    var bf = cmp.querySelector('.cmp__before');
    if(!r) return;
    r.addEventListener('input', function(){
      var p = r.value + '%';
      cmp.style.setProperty('--pos', p);
      if(bf) bf.style.clipPath = 'inset(0 calc(100% - ' + p + ') 0 0)';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
